import { ADD_PRODUTO, LIMPAR_CARRINHO, EXCLUIR_PRODUTO, ATUALIZA_QTD_PRODUTO } from './mutation-types'

export default {
    [ADD_PRODUTO](state, payload) {
        let produtoParaCarrinho = {
            id: payload.id,
            nome: payload.nome,
            preco: payload.preco,
            quantidadeTotal: 1,
            precoTotal: payload.preco
        }
        state.produtos = state.produtos.concat(produtoParaCarrinho);
    },
    [LIMPAR_CARRINHO](state){
        state.produtos = []
    },
    [EXCLUIR_PRODUTO](state, idProduto){
        let index = state.produtos.findIndex(x => x.id == idProduto)
        state.produtos.splice(index, 1)
    },
    [ATUALIZA_QTD_PRODUTO](state, idProduto){
        let produto = state.produtos.find(prod => prod.id == idProduto);
        produto.precoTotal += produto.preco;
        produto.quantidadeTotal += 1;
    }
}